import React from "react";
import { SparklesIcon } from "@heroicons/react/24/outline";
import backgroundImage from "../assets/bg-golf-course.jpeg"; // Adjust the path as necessary

const Loading: React.FC = () => {
  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="flex flex-col items-center">
        <SparklesIcon className="h-24 w-24 animate-spin text-green-500" />
        <p className="mt-4 text-white text-xl">Loading...</p>
      </div>
    </div>
  );
};

export default Loading;
